import React from 'react'

const CustomStyles: React.FC = () => {
  const colorLightGreyLight = '#eaf0f3'
  const colorLightGreyLightest = '#f4f7f9'

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
  .hover\\:bg-lightgrey-light:hover{background-color:${colorLightGreyLight}}
  .hover\\:text-lightgrey-lightest:hover{color:${colorLightGreyLightest}}
  .-scale-100{transform:scale(-1)}
  .placeholder-dark::placeholder{color:#252525;opacity: 1;}
  .placeholder-dark:-ms-input-placeholder{color:#252525;}
  .placeholder-dark::-ms-input-placeholder{color:#252525;}
  .uif-top-edge{top:100%}
  .uif-shadow{box-shadow:0 11px 17px 0 rgba(0, 0, 0, 0.23)}
  .uif-w-67{width:4.1875rem}
  .uif-w-260{width:16.25rem}
  .uif-left-260{left:16.25rem}
  .uif-text-10{font-size: 0.625rem}
  @media (min-width:360px) { /* xs */
    .xs\\:text-12{font-size: 0.75rem}
  }
  @media (min-width:768px) { /* sm */
    .sm\\:uif-max-w-718{max-width:44.875rem}
    .sm\\:uif-max-w-560{max-width:35rem}
    .sm\\:uif-w-101{width:6.3125rem}
  }
  @media (min-width:992px) { /* md */
    .md\\:uif-max-w-942{max-width:58.875rem}
  }
  @media (min-width:1200px) {  /* lg */
    .lg\\:uif-max-w-1160{max-width:72.5rem}
  }
  `,
      }}
    />
  )
}

export default CustomStyles
